import { render, staticRenderFns } from "./DatasetSourceTransform.vue?vue&type=template&id=23ed771f&scoped=true"
import script from "./DatasetSourceTransform.vue?vue&type=script&lang=js"
export * from "./DatasetSourceTransform.vue?vue&type=script&lang=js"
import style0 from "./DatasetSourceTransform.vue?vue&type=style&index=0&id=23ed771f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ed771f",
  null
  
)

export default component.exports